var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 525.89 222.89",
    style: {
      enableBackground: "new 0 0 525.89 222.89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#E73E11;stroke-width:0.5;stroke-miterlimit:10;}\r\n\t.st1{fill:#E73E11;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\r\n\t.st4{fill:#E73E11;stroke:#E73E11;stroke-width:0.5;stroke-miterlimit:10;}\r\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:7;stroke-miterlimit:10;}\r\n\t.st6{fill:none;stroke:#FFFFFF;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st7{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "390.04,160.82 390.04,173.18 390.44,173.18 409.79,173.18 409.81,155.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.01,37.94c1.54-1.87,3.56-4.02,6.16-6.16c2.32-1.91,4.56-3.36,6.51-4.45c7.9,0,15.81,0,23.71,0 c0.9,0.59,2.21,1.5,3.68,2.74c6.19,5.22,9.14,11.13,11.13,15.24c5.63,11.6,8.44,17.4,10.62,22.26c2.28,5.11,5.67,12.48,10.1,21.38 l21.4-52.89c0.41-1.19,1.63-4.24,4.79-6.51c2.06-1.47,4.09-2.01,5.29-2.23c7.85,0,15.69,0,23.54,0c1.89,0.41,5.74,1.55,8.49,4.97 c3.42,4.25,3.06,9.47,2.74,14.04c-0.19,2.69-0.82,6.93-3.07,11.8L161,130.91v53.76h-35.91c-0.79-0.27-1.96-0.76-3.13-1.71 c-2.96-2.4-3.69-5.89-4.11-7.88c-0.25-1.18-0.5-2.95-0.34-5.14c0-12.9,0-25.8,0-38.69L67.01,37.94z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M235.99,76.69c6.33,0,11.47,5.14,11.47,11.47s-5.14,11.47-11.47,11.47s-11.47-5.14-11.47-11.47 S229.66,76.69,235.99,76.69z M226.1,108.33h19.77v64.06H226.1V108.33z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M322.62,163.41c-0.23-0.43-0.44-0.87-0.63-1.32 M323.35,164.66c-0.26-0.4-0.5-0.82-0.73-1.24 M363.81,165.86 v-1.4h-0.26c-0.2,0.32-0.41,0.63-0.63,0.92 M321.98,162.1c-0.99-2.28-1.53-4.88-1.53-7.79c0-22.14,26.89-22.54,43.36-22.54 c0-6.99-5.8-11.47-12.65-11.47c-6.46,0-11.86,2.9-16.08,7.64l-10.54-10.81c7.25-6.85,17.79-10.28,28.21-10.28 c23.07,0,29.26,11.73,29.26,33.08v21.79 M358.94,144.42c-6.06,0-19.51,0.53-19.51,9.23c0,4.75,5.01,6.99,9.36,6.99 c7.78,0,15.03-4.09,15.03-12v-4.22H358.94z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196.64,73.28h19.77v99.65h-19.77V73.28z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M390.04,159.78v-50.87h19.77v10.28h0.26c4.22-7.78,9.75-11.86,18.45-11.86c2.24,0,4.75,0.13,6.59,0.66v18.06 c-2.77-0.79-5.54-1.32-8.44-1.32c-15.03,0-16.87,8.7-16.87,21.49v9.09"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 450.74,
    cy: 119.44,
    r: 9.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M164.21,179.82"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M295.79,162.44v-20.67c0-7.38-0.13-16.87-10.28-16.87c-10.28,0-11.86,8.04-11.86,16.34v31.9h-19.77v-64.06 h18.98v8.7h0.26c2.64-5.01,9.1-10.28,18.72-10.28c20.03,0,23.72,13.18,23.72,30.32v24.88"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "295.78,162.76 295.78,173.15 315.57,173.15 315.57,162.46  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "362.92,166.9 362.92,173.18 382,173.18 382,162.95  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "195.78,185.18 249.21,185.18 296.23,165.43 357.73,165.43 413.27,151.45 444.06,126.59  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0daafbee4a11eb55988458b529ce85c7.svg";
export { ForwardRef as ReactComponent };